import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";
import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";
import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import axios from 'axios';
import tableDataComplex from "./variables/tableDataComplex.json";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [userrole, setUserrole] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
const [totalCount,setTotalCount]=useState(0)
const [error,setError]=useState("")
const [inspectioncount,setInspectioncount]=useState(0)
const [filecount,setFilecount]=useState(0)
const [compliancecount,setCompliancecount]=useState(0)
const [userscount,setUserscount]=useState(0)
const [violationcount,setViolationcount]=useState(0)
const [myInspectionCount,setMyInspectionCount]=useState(0)
const [penaltyIssued ,setPenaltyIssued]=useState(0)
const [violationfound ,setViolationfound]=useState(0)
const [mycompliance ,setMycompliance ]=useState(0)
const [myfilecount,setMyfilecount]=useState(0)
const api=axios.create({
  baseURL:process.env.REACT_APP_API_URL,
       headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
})


const token=localStorage.getItem('token')

   api.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });


const fetchTotalCount = async () => {
    setLoading(true);
    setError(null);

    try {
        // Fetching from TWO separate APIs
        const [tradersRes, inspectionsRes] = await Promise.all([
            api.get('/totaltraders'),
            api.get('/inspectorsInspection')
        ]);

        // Handle first API response
        if (tradersRes.data.success) {
            setTotalCount(tradersRes.data.totalCount || 0);
        }

        // Handle second API response
        if (inspectionsRes.data.success) {
            setInspectioncount(inspectionsRes.data.inspectioncount || 0);
            setFilecount(inspectionsRes.data.filecount || 0);
            setCompliancecount(inspectionsRes.data.compliancecount || 0);
            setUserscount(inspectionsRes.data.userscount || 0);
            setViolationcount(inspectionsRes.data.violationcount || 0);
            setMyInspectionCount(inspectionsRes.data.myInspectionCount || 0);
            setPenaltyIssued(inspectionsRes.data.penaltyIssued)
            setViolationfound(inspectionsRes.data.violationfound)
            setMycompliance(inspectionsRes.data.mycompliance)
            setMyfilecount(inspectionsRes.data.myfilecount)
        }

    } catch (error) {
        console.error('Error fetching counts:', error);
        setError('Failed to load dashboard counts');

        // Reset all counts on error
        setTotalCount(0);
        setInspectioncount(0);
        setFilecount(0);
        setCompliancecount(0);
        setUserscount(0);
        setViolationcount(0);
        setMyInspectionCount(0);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    fetchTotalCount();
}, []);


















  
  async function GetUsers() {
    try {
      setLoading(true);
      const response = await api.get('/userroles');
      // Fix: response.data, not response.json()
      const data = response.data;
      
     setUserrole(data.userrole); // Access the userrole property
      console.log('User role:', data);
    } catch (error) {
      console.error('Error fetching user role:', error);
      if (error.response?.status === 401) {
        console.log('User not authenticated - redirect to login');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    GetUsers();
  }, []);

  console.log("user role in adminasabor", userrole);

  // Loading state
 if (loading) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
      <div className="text-center">
        <div className="relative inline-block">
          {/* Spinner */}
          <div className="w-16 h-16 border-4 border-indigo-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-indigo-700 rounded-full animate-spin border-t-transparent"></div>
          
          {/* Inner icon */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <svg className="w-6 h-6 text-indigo-600 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </div>
        </div>
        
        <h3 className="mt-6 text-xl font-semibold text-gray-800">Loading Dashboard</h3>
        <p className="mt-2 text-gray-500">Please wait while we fetch your data...</p>
        
        {/* Loading steps */}
        <div className="mt-6 space-y-2">
          {['Fetching inspections', 'Loading statistics', 'Preparing charts'].map((step, index) => (
            <div key={step} className="flex items-center justify-center space-x-2 text-sm text-gray-500">
              <div className={`w-1.5 h-1.5 rounded-full ${index === 0 ? 'bg-indigo-600 animate-pulse' : 'bg-gray-300'}`}></div>
              <span className={index === 0 ? 'text-indigo-600' : ''}>{step}</span>
              {index === 0 && (
                <svg className="w-3 h-3 text-indigo-600 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

  // Admin Dashboard Content
  const AdminDashboard = () => (
    <div>
      {/* Card widget */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Traders"}
          subtitle={totalCount}
        />
   <Widget 
    className="bg-indigo-700 hover:bg-indigo-800 text-white rounded-xl shadow-lg transition-colors"
    icon={<IoDocuments className="h-6 w-6" />}
    title="Inspections"
    subtitle={inspectioncount}
/>
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Complaints"}
          subtitle={compliancecount}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Files"}
          subtitle={filecount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Users"}
          subtitle={userscount}
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Violations"}
          subtitle={violationfound}
        />
      </div>

      {/* Charts */}
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
      
    
      </div>

      {/* Tables & Charts */}
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
       
        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <TaskCard />
        </div>
       
        <div>
         
           <PieChartCard />
        </div>
  
      </div>
    </div>
  );

  // Inspector Dashboard Content
  const InspectorDashboard = () => (
    <div>
      {/* Card widget */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Traders"}
           subtitle={totalCount}
        />
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"My Inspections"}
          subtitle={myInspectionCount }
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"My Compliance"}
          subtitle={mycompliance }
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Penality Issued"}
          subtitle={myInspectionCount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Violation Found"}
          subtitle={violationfound}
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"My Files"}
          subtitle={myfilecount}
        />
      </div>

      {/* Charts */}
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
         <MiniCalendar />
      </div>

      {/* Tables */}
     
    </div>
  );

  // User Dashboard Content
  const UserDashboard = () => (
    <div>
      {/* Card widget */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
    
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"My Complaints"}
          subtitle={mycompliance }
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"My Files"}
          subtitle={myfilecount}
        />
  
       
         <MiniCalendar />
      </div>

      {/* Charts */}
     

      {/* Tables */}
     
    </div>
  );

   const TradersDashboard = () => (
    <div>
      {/* Card widget */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"My Inspections"}
          subtitle={myInspectionCount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"My Complaints"}
          subtitle={compliancecount}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"My Files"}
          subtitle={filecount}
        />
  
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Violations"}
          subtitle={violationfound}
        />
         <MiniCalendar />
      </div>

      {/* Charts */}
     

      {/* Tables */}
     
    </div>
  );

  // Render appropriate dashboard based on user role
  if (userrole === 'admin') {
    return <AdminDashboard />;
  } else if (userrole === 'inspector') {
    return <InspectorDashboard />;
  } else if (userrole === 'user') {
    return <UserDashboard />;
  }
    else if (userrole === 'trader') {
    return <TradersDashboard />
  }
};

export default Dashboard;